import React from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Row, Upload, Modal, message } from "antd";
import axios from "axios";
import { getDownloadSignedUrl, getUploadSignedUrl } from "../../utils/s3_helper";
import "./style.css";

class ImageUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [],
      previewVisible: false,
      previewImage: ""
    };
  }

  uploadToS3 = async ({
    action,
    data,
    file,
    filename,
    headers,
    onError,
    onProgress,
    onSuccess,
    withCredentials
  }) => {
    const actionData = await getUploadSignedUrl(filename, file.type, {headers: headers});
    const signedUrl = actionData.signedUrl;
    const publicUrl = actionData.publicUrl;
    console.log("Recieved a signed request " + signedUrl);
    // Put the fileType in the headers for the upload
    var options = {
      onUploadProgress: event => {
        onProgress({ percent: (event.loaded / event.total) * 100 });
      },
      headers: {
        'Content-Type': file.type
      }
    };
    await axios.put(signedUrl, file, options)
    .then(result => {
      console.log("Response from s3", result);
      onSuccess(publicUrl, file);
    })
    .catch(error => {
      console.log(error);
      onError(error);
    });
  };

  componentDidMount() {
    this.updateFileList();
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.value) !== JSON.stringify(this.props.value)) {
      this.updateFileList();
    }
  }

  updateFileList = async () => {
    let fileList;
    if (this.props.multiple) {
      fileList = this.props.value.map(async (v, i) => {
        const downloadUrl = await getDownloadSignedUrl(v, {headers: this.props.headers});
        return({
          uid: i,
          name: `image-${i}`,
          response: v,
          url: downloadUrl
        });
      });
    } else {
      if (this.props.value) {
        const downloadUrl = await getDownloadSignedUrl(this.props.value, {headers: this.props.headers});
        fileList = [
          {
            uid: 0,
            name: this.props.name,
            response: this.props.value,
            url: downloadUrl
          }
        ];
      }
      else 
        fileList = [];
    }
    this.setState({ fileList });
  };

  handleChange = ({ file, fileList }) => {
    if (fileList.length) {
      let data = fileList.map(img => img.response);
      this.props.onSuccess(data);
    } else {
      this.props.multiple
        ? this.props.onSuccess([])
        : this.props.onSuccess([""]);
    }
    this.setState({ fileList });
  };

  handlePreview = async(file) => {
    this.setState({
      previewImage: file.url,
      previewVisible: true
    });
  };

  handleCancel = () => {
    this.setState({
      previewVisible: false,
      previewImage: ""
    });
  };

  beforeUpload = file => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error("Upload only JPEG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image size must be less than 2MB!");
    }
    return isJpgOrPng && isLt2M;
  }

  render() {
    const { fileList } = this.state;
    return (
      <React.Fragment>
        <Row type="flex" justify="start" align="top">
          <div className="text-center my-0 mx-auto">
            <Row type="flex" justify="start" align="middle">
              <Upload
                accept={this.props.accept || ""}
                className={this.props.className}
                name={this.props.name}
                headers={this.props.headers}
                customRequest={this.uploadToS3}
                listType="picture-card"
                onPreview={this.handlePreview}
                fileList={fileList}
                onChange={this.handleChange}
                multiple={this.props.multiple}
                beforeUpload={this.beforeUpload}
              >
                {/* {fileList.length === 0 ? ( */}
                {!this.props.multiple && this.props.value ? 
                  null :
                  <div>
                    <PlusOutlined />
                    <div className="ant-upload-text">Upload</div>
                  </div>
                }
              </Upload>
            </Row>
          </div>
        </Row>

        <Modal
          visible={this.state.previewVisible}
          footer={null}
          onCancel={this.handleCancel}
        >
          <img
            alt="preview"
            style={{ width: "100%" }}
            src={this.state.previewImage}
          />
        </Modal>
      </React.Fragment>
    );
  }
}

export default ImageUpload;
